
export default {
  setOpenId(state,openId) {
    state.openId = openId
    localStorage.setItem('eleH5OpenId',openId)
  },
  setToken(state,token) {
    state.token = token
    localStorage.setItem('eleH5Token',token)
  },  
  setUserId(state,userId) {
    state.userId = userId
    localStorage.setItem('eleH5UserId',userId)
  },
  setUserUniqueId(state,userUniqueId) {
    state.userUniqueId = userUniqueId
    localStorage.setItem('eleH5UserUniqueId',userUniqueId)
  },

  setStudentNo(state,studentNo) {
    state.studentNo = studentNo
    localStorage.setItem('eleH5StudentNo',studentNo)
  },
  setApprovalStatus(state,approvalStatus) {
    state.approvalStatus = approvalStatus
    localStorage.setItem('eleH5ApprovalStatus',approvalStatus)
  },
  


  // 头像
  setPhoto(state,photo) {
    state.photo = photo
  },
  // 身份�?
  setIdCard(state,idCard) {
    state.idCard = idCard
  },
  // 前置毕业
  setPreposeDiploma(state,preposeDiploma) {
    state.preposeDiploma = preposeDiploma
  },
  // 前置毕业
  setWorkCertificate(state,workCertificate) {
    state.workCertificate = workCertificate
  }

  
};
